function checkGuaranteeBadge() {
  const badgeEl = document.querySelector('.guarantee-badge');
  const guarantee = badgeEl?.dataset?.guarantee
  const is3MonthsGaurantee = guarantee ? true : false;
  const contentElSelector = badgeEl?.dataset?.selector;
  const contentEl = document.getElementById(contentElSelector);
  let variation;
  
  if ((contentEl && contentEl.textContent.includes('3 Months Guarantee')) || is3MonthsGaurantee) {
    variation = "Original";
    if (badgeEl) badgeEl.style.display = 'flex';
  } else {
    variation = "Variant";
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'three_months_guarantee_seen',
    variation: variation
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkGuaranteeBadge);
} else {
  checkGuaranteeBadge();
}
